import { useState } from "react";
import { motion } from "framer-motion";
import { Zap, Lightbulb, Target, TrendingUp, Mail, Phone, MapPin } from "lucide-react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import WhyChooseUs from "@/components/WhyChooseUs";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#020408] relative overflow-x-hidden">
      <div className="fixed inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Ccircle cx="1" cy="1" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          backgroundSize: '30px 30px'
        }} />
      </div>
      
      <div className="absolute top-40 left-20 w-96 h-96 bg-pink-500/20 rounded-full blur-[120px]" />
      <div className="absolute top-60 right-20 w-96 h-96 bg-lime-500/20 rounded-full blur-[120px]" />
      <div className="absolute bottom-40 left-1/2 w-96 h-96 bg-orange-500/10 rounded-full blur-[120px]" />
      
      <Navbar />
      <Hero />
      <Features />
      <WhyChooseUs />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default LandingPage;
